import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export { AuthContext };

// Mock AuthProvider - no backend functionality
export const AuthProvider = ({ children }) => {
  const [user] = useState(null);
  const [loading] = useState(false);

  const value = {
    user,
    loading,
    register: async () => ({ data: null, error: new Error('Backend not available') }),
    login: async () => ({ data: null, error: new Error('Backend not available') }),
    logout: async () => {},
    updateLastLogin: async () => {}
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
